function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "191115_VF_Icon_calendar_NDN"), /*#__PURE__*/React.createElement("path", {
  d: "M212.5 14.5V7.3h-28.1v7.2H99.1V7.3H71v7.2H0v269h283.5v-269h-71zm42.8 241H28.1V106.7h227.2v148.8zm0-177.7H28.1V42.6H71v14.3h28.1V42.6h85.4v14.3h28.1V42.6h42.8v35.2h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.4 211.9H88.8V190l57.6-61.1h33.8V190h14.5v21.9h-14.5v22h-26.7v-22zm0-21.9v-36.1h-.2L119.5 190h33.9z"
})));